import { ActionTree, Module, MutationTree } from 'vuex'
import { RootState } from '../types'
import repository from '@/repository'

const getDefaultState = (): ExternalTokenState => {
  return {
    externalTokenList: [],
    isLoading: false,
    errorMessage: '',
    isError: false,
  }
}

const state = getDefaultState()

const mutations: MutationTree<ExternalTokenState> = {
  reset(state) {
    Object.assign(state, getDefaultState())
  },
  setExternalTokenList(state, value) {
    state.externalTokenList = value
  },
  setIsLoading(state, value) {
    state.isLoading = value
  },
  setErrorMessage(state, value) {
    state.errorMessage = value
  },
  setIsError(state, value) {
    state.isError = value
  },
  setUpdateExternalToken(state, value) {
    state.externalTokenList = state.externalTokenList.map((item) =>
      item.id === value.id ? value : item
    )
  },
}

const actions: ActionTree<ExternalTokenState, RootState> = {
  async fetchExternalTokenList({ commit }, payload) {
    commit('setIsLoading', true)
    commit('setIsError', false)
    commit('setErrorMessage', '')
    return repository.ExternalToken.GetByDealer(payload)
      .then((response: { data: Array<any> }) => {
        commit('setExternalTokenList', response.data)
      })
      .catch(
        (error: { response?: { data?: { messageLocalizable?: string } } }) => {
          commit('setIsError', true)
          commit(
            'setErrorMessage',
            error.response?.data?.messageLocalizable ||
              'ErrorMessageLocalizable'
          )
        }
      )
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  async createExternalToken({ commit }, payload) {
    commit('setIsLoading', true)
    commit('setIsError', false)
    commit('setErrorMessage', '')
    return repository.ExternalToken.Create(payload)
      .then((res) => {
        return res.data
      })
      .catch((err) => {
        commit('setIsError', true)
        commit('setErrorMessage', err.response.data.messageLocalizable)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  async updateExternalToken({ commit }, payload) {
    commit('setIsLoading', true)
    commit('setIsError', false)
    commit('setErrorMessage', '')
    return repository.ExternalToken.Update(payload)
      .then((res) => {
        commit('setUpdateExternalToken', res.data)
        return res.data
      })
      .catch((err) => {
        commit('setIsError', true)
        commit('setErrorMessage', err.response.data.messageLocalizable)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  clearErrorMessage({ commit }) {
    commit('setIsError', false)
    commit('setErrorMessage', '')
  },
}

const ExternalToken: Module<ExternalTokenState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default ExternalToken

interface ExternalTokenState {
  externalTokenList: Array<any>
  isLoading: boolean
  errorMessage: string
  isError: boolean
}
